// Phase 41 D-01/D-05/D-20/D-22: canonical 20-value plant-type enum. Lucide fallbacks until design SVGs land; swap import lines only when SVGs arrive.
import { Shrub, Trees, Flower2, Leaf, Droplets, Scissors, ArrowUpDown, Sprout, LeafyGreen, Barcode } from 'lucide-react';

// SVG imports wired when design delivers files — swap Lucide fallback for the ?react import:
// import EvergreenTree from '../assets/plant-types/evergreen-tree.svg?react'; ← future
// (vite-plugin-svgr is installed and configured — no build-system changes needed)

export const PLANT_TYPES = Object.freeze([
  { id: 'annual',          label: 'Annual',          Icon: Flower2     },
  { id: 'bamboo',          label: 'Bamboo',          Icon: Barcode     },
  { id: 'biennial',        label: 'Biennial',        Icon: Flower2     },
  { id: 'bulb',            label: 'Bulb',            Icon: Droplets    },
  { id: 'climber',         label: 'Climber',         Icon: ArrowUpDown },
  { id: 'conifer',         label: 'Conifer',         Icon: Trees       },
  { id: 'evergreen shrub', label: 'Evergreen shrub', Icon: Leaf        },
  { id: 'evergreen tree',  label: 'Evergreen tree',  Icon: Trees       },
  { id: 'fern',            label: 'Fern',            Icon: LeafyGreen  },
  { id: 'fruit bush',      label: 'Fruit bush',      Icon: Sprout      },
  { id: 'fruit tree',      label: 'Fruit tree',      Icon: Trees       },
  { id: 'grass',           label: 'Grass',           Icon: Barcode     },
  { id: 'herb',            label: 'Herb',            Icon: Sprout      },
  { id: 'houseplant',      label: 'Houseplant',      Icon: Leaf        },
  { id: 'perennial',       label: 'Perennial',       Icon: Flower2     },
  { id: 'shrub',           label: 'Shrub',           Icon: Shrub       },
  { id: 'succulent',       label: 'Succulent',       Icon: Leaf        },
  { id: 'topiary',         label: 'Topiary',         Icon: Scissors    },
  { id: 'tree',            label: 'Tree',            Icon: Trees       },
  { id: 'vegetable',       label: 'Vegetable',       Icon: Sprout      },
]);

export const PLANT_TYPE_IDS   = Object.freeze(PLANT_TYPES.map(t => t.id));
export const PLANT_TYPE_BY_ID = Object.freeze(Object.fromEntries(PLANT_TYPES.map(t => [t.id, t])));
